import React from "react";
import AnalyticsIcon from "../../../../../assets/svg/analytics-icon";
import CheckedIcon from "../../../../../assets/svg/checked-icon";
import KnowledgeBaseIcon from "../../../../../assets/svg/knowledge-base-icon";
import StarIcon from "../../../../../assets/svg/star-icon";
import { getHelpdeskLabels, getRegionLabel } from "../../../../../utils/constants/mappings";

export interface HelpDeskTab {
  id: string;
  label: string;
  path: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  iconClass: string;
}

export const getHelpDeskTabs = (clientCode?: string, region?: string): HelpDeskTab[] => {
  const helpdeskLabels = getHelpdeskLabels(region);
  return [
    {
      id: "all-tickets",
      label: helpdeskLabels.allTickets,
      path: "/dashboard/crm/helpdesk/all-tickets",
      icon: CheckedIcon,
      iconClass: "w-3 h-3 shrink-0",
    },
    {
      id: "feature-requests",
      label: "Feature Requests",
      path: "/dashboard/crm/helpdesk/all-tickets?helpdesk_filter=feature-request",
      icon: StarIcon,
      iconClass: "w-4 h-4 shrink-0",
    },
    {
      id: "ticket-reports",
      label: helpdeskLabels.ticketReports,
      path: "/dashboard/crm/helpdesk/ticket-reports",
      icon: AnalyticsIcon,
      iconClass: "w-4 h-4 shrink-0",
    },
    {
      id: "knowledge-base",
      label: getRegionLabel("knowledgeBaseSection", clientCode),
      path: "/dashboard/crm/helpdesk/knowledge-base",
      icon: KnowledgeBaseIcon,
      iconClass: "w-4 h-4 shrink-0",
    },
  ];
};

export const TICKET_LOG_PRIORITY_STYLES = {
  high: {
    text: "text-verba-red-alert dark:text-verba-red-alert-dk",
    flag: "text-verba-red-alert dark:text-verba-red-alert-dk",
  },
  low: {
    text: "text-verba-blue dark:text-verba-blue-dk",
    flag: "text-verba-blue dark:text-verba-blue-dk",
  },
  normal: {
    text: "text-dark-yellow-for-alerts dark:text-dark-yellow-for-alerts-dk",
    flag: "text-dark-yellow-for-alerts dark:text-dark-yellow-for-alerts-dk",
  },
} as const;

export const TICKET_LOG_SHIMMER_CLASS =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

export const TICKET_LOG_SHIMMER_WIDTHS: [string, string][] = [
  ["w-[70%]", "w-[45%]"],
  ["w-[85%]", "w-[50%]"],
  ["w-[60%]", "w-[40%]"],
  ["w-[90%]", "w-[55%]"],
  ["w-[50%]", "w-[35%]"],
];
